// extracted by mini-css-extract-plugin
module.exports = {"root":"NoLoansPanel_root__1ht1d","hide":"NoLoansPanel_hide__1c4kG","description":"NoLoansPanel_description__3_y8J","buttons":"NoLoansPanel_buttons__1dZXS"};